// Simple, dependency-free SVG glyphs used inside map markers.
// Kept as plain <svg> so they don't pull in an icon library.

export function DoorLockIcon({ size = 13, color = '#0a0e0c' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
      <path d="M6 10V7a6 6 0 0 1 12 0v3h1a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h1zm2 0h8V7a4 4 0 0 0-8 0v3z" />
    </svg>
  );
}

export function PlaneCrashIcon({ size = 13, color = '#0a0e0c' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
      <path d="M2 21l7-2 11-11-4-4L5 15l-2 6zm14.5-15.5l3 3-1.4 1.4-3-3z" />
    </svg>
  );
}
